// This file is generated by the update-rd-teams script. Run "pnpm update:rd-teams" to update.
// It needs to be pushed to the repository. Otherwise, all builds could break if a team changes.
export var teams = {
    'ai-enablement-committee': {
        slug: 'ai-enablement-committee',
        displayName: 'AI Enablement Committee',
        units: [
            'dx'
        ],
        jiraProjects: [
            {
                key: 'AIE'
            }
        ],
        contact: {}
    },
    'backend-foundation': {
        slug: 'backend-foundation',
        displayName: 'Backend Foundation',
        aliases: [
            'platform-foundation',
            'service-foundation',
            'foundation'
        ],
        units: [
            'platform-engineering'
        ],
        jiraProjects: [
            {
                key: 'FOUND'
            }
        ],
        contact: {
            slack: '#community-backend-foundation',
            supportPortals: [
                {
                    label: "Backend Foundation's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/278'
                }
            ]
        }
    },
    cartel: {
        slug: 'cartel',
        displayName: 'commerce-cartel',
        units: [
            'commerce'
        ],
        jiraProjects: [
            {
                key: 'COMSHOPX'
            }
        ],
        contact: {
            slack: '#commerce-rd-cart-el',
            supportPortals: []
        }
    },
    'cloud-infra': {
        slug: 'cloud-infra',
        displayName: 'Cloud Infrastructure',
        aliases: [
            'infrastructure',
            'cloudinfra',
            'infra'
        ],
        units: [
            'platform-engineering'
        ],
        jiraProjects: [
            {
                key: 'CLOUDINFRA'
            }
        ],
        contact: {
            slack: '#community-infra',
            supportPortals: [
                {
                    label: "Infrastructure's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/147'
                }
            ]
        }
    },
    'cloud-intelligence': {
        slug: 'cloud-intelligence',
        displayName: 'Cloud Intelligence',
        aliases: [
            'finops',
            'cloud-ops',
            'ops',
            'sre'
        ],
        units: [
            'platform-engineering'
        ],
        jiraProjects: [
            {
                key: 'SRE'
            },
            {
                key: 'FINOPS'
            },
            {
                key: 'CIA'
            }
        ],
        contact: {
            supportPortals: [
                {
                    label: "Analytics and Insight's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/211'
                },
                {
                    label: "SRE's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/145'
                },
                {
                    label: "FinOps's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/212'
                }
            ]
        }
    },
    'commerce-frontend': {
        slug: 'commerce-frontend',
        displayName: 'Commerce Frontend',
        aliases: [
            'commerce-administrators'
        ],
        units: [
            'commerce'
        ],
        jiraProjects: [
            {
                key: 'MHUB'
            }
        ],
        contact: {
            slack: '#commerce-rd-frontend'
        }
    },
    'commerce-implement': {
        slug: 'commerce-implement',
        displayName: 'Commerce Implement',
        units: [
            'commerce'
        ],
        jiraProjects: [
            {
                key: 'LENS'
            }
        ],
        contact: {
            slack: '#community-commerce'
        }
    },
    'commerce-routemasters': {
        slug: 'commerce-routemasters',
        displayName: 'Commerce Routemasters',
        aliases: [
            'commerce-analyze',
            'commerce-engage-recs-badging-content',
            'commerce-rbc',
            'commerce-engage-search-listing',
            'commerce-sdz'
        ],
        units: [
            'commerce'
        ],
        jiraProjects: [
            {
                key: 'CAPI'
            }
        ],
        contact: {
            slack: '#support-commerce'
        }
    },
    'commerce-shopify': {
        slug: 'commerce-shopify',
        displayName: 'Commerce Shopify',
        units: [
            'commerce'
        ],
        jiraProjects: [
            {
                key: 'LENS'
            }
        ],
        contact: {
            slack: '#commerce-rd-typescript'
        }
    },
    'connectivity-core': {
        slug: 'connectivity-core',
        displayName: 'Connectivity Core',
        units: [
            'content-ingestion'
        ],
        jiraProjects: [
            {
                key: 'CTCORE'
            }
        ],
        contact: {
            slack: '#community-content-ingestion'
        }
    },
    'coveo-labs-technical-powerhouse': {
        slug: 'coveo-labs-technical-powerhouse',
        displayName: 'Coveo Labs Technical Powerhouse',
        units: [
            'advisors-and-specialists'
        ],
        jiraProjects: [
            {
                key: 'LAB'
            },
            {
                key: 'UNI'
            }
        ],
        contact: {
            slack: '#coveo-labs'
        }
    },
    ctinfra: {
        slug: 'ctinfra',
        displayName: 'Connectors Infrastructure',
        aliases: [
            'connectors-infrastructure'
        ],
        units: [
            'content-ingestion'
        ],
        jiraProjects: [
            {
                key: 'CTINFRA'
            }
        ],
        contact: {
            slack: '#community-content-ingestion'
        }
    },
    'data-analytics-engineering': {
        slug: 'data-analytics-engineering',
        displayName: 'Data Analytics Engineering',
        aliases: [
            'commerce-paparazzi'
        ],
        units: [
            'data-platform'
        ],
        jiraProjects: [
            {
                key: 'DAE'
            }
        ],
        contact: {
            slack: '#support-dataplatform'
        }
    },
    'data-integration': {
        slug: 'data-integration',
        displayName: 'Data Integration',
        units: [
            'data-platform'
        ],
        jiraProjects: [
            {
                key: 'DI'
            }
        ],
        contact: {
            supportPortals: [],
            slack: '#team-data-integration'
        }
    },
    'database-data-management': {
        slug: 'database-data-management',
        displayName: 'Database & Data Management',
        units: [
            'data-platform'
        ],
        jiraProjects: [
            {
                key: 'DDM'
            }
        ],
        contact: {
            slack: '#support-dataplatform'
        }
    },
    dataplatformfoundation: {
        slug: 'dataplatformfoundation',
        displayName: 'Data Platform Foundation',
        aliases: [
            'usageanalytics',
            'data-foundation'
        ],
        units: [
            'data-platform'
        ],
        jiraProjects: [
            {
                key: 'UA'
            }
        ],
        contact: {
            slack: '#support-dataplatform'
        }
    },
    'dev-docs': {
        slug: 'dev-docs',
        displayName: 'Developer Documentation',
        aliases: [
            'dev-writers',
            'api-writers'
        ],
        units: [
            'dx'
        ],
        jiraProjects: [
            {
                key: 'DOC'
            }
        ],
        contact: {}
    },
    'dev-tooling': {
        slug: 'dev-tooling',
        displayName: 'Dev Tooling',
        aliases: [
            'cicd',
            'devtooling'
        ],
        units: [
            'platform-engineering'
        ],
        jiraProjects: [
            {
                key: 'DT'
            }
        ],
        contact: {
            slack: '#community-dev_tooling',
            supportPortals: [
                {
                    label: "Dev Tooling's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/178'
                }
            ]
        }
    },
    documentation: {
        slug: 'documentation',
        displayName: 'Documentation',
        units: [
            'product-experience'
        ],
        jiraProjects: [
            {
                key: 'DOC'
            }
        ],
        contact: {
            slack: '#public-documentation'
        }
    },
    dxui: {
        slug: 'dxui',
        displayName: 'DXUI',
        aliases: [
            'dx',
            'search-ui',
            'searchui'
        ],
        units: [
            'dx'
        ],
        jiraProjects: [
            {
                key: 'KIT'
            }
        ],
        contact: {}
    },
    'frontend-foundation': {
        slug: 'frontend-foundation',
        displayName: 'Frontend Foundation',
        aliases: [
            'admin-ui',
            'admin-ui-core',
            'ui-tooling',
            'admin-specialists'
        ],
        units: [
            'platform-engineering'
        ],
        jiraProjects: [
            {
                key: 'ADUI'
            }
        ],
        contact: {
            slack: '#community-frontend-foundation',
            supportPortals: [
                {
                    label: "Frontend Foundation's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/277'
                }
            ]
        }
    },
    'generic-connectivity': {
        slug: 'generic-connectivity',
        displayName: 'Generic Connectivity',
        aliases: [
            'websites'
        ],
        units: [
            'content-ingestion'
        ],
        jiraProjects: [
            {
                key: 'CTGEN'
            }
        ],
        contact: {
            slack: '#community-content-ingestion'
        }
    },
    grc: {
        slug: 'grc',
        displayName: 'Governance, Risk & Compliance',
        units: [
            'corpo-security'
        ],
        jiraProjects: [
            {
                key: 'CSEC'
            },
            {
                key: 'RISK'
            }
        ],
        contact: {
            slack: '#security',
            supportPortals: [
                {
                    label: "GRC's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/13'
                }
            ]
        }
    },
    'index-indexing': {
        slug: 'index-indexing',
        displayName: 'Index Indexing',
        aliases: [
            'index',
            'index-core',
            'indexing-pipeline'
        ],
        units: [
            'query-execution'
        ],
        jiraProjects: [
            {
                key: 'IDX'
            },
            {
                key: 'IXI'
            }
        ],
        contact: {
            slack: '#support-index'
        }
    },
    'index-infrastructure': {
        slug: 'index-infrastructure',
        displayName: 'Index Infrastructure',
        units: [
            'query-execution'
        ],
        jiraProjects: [
            {
                key: 'IDXINFRA'
            }
        ],
        contact: {
            slack: '#support-index-infra'
        }
    },
    'index-querying': {
        slug: 'index-querying',
        displayName: 'Index Querying',
        aliases: [
            'index-core-search'
        ],
        units: [
            'query-execution'
        ],
        jiraProjects: [
            {
                key: 'IDX'
            },
            {
                key: 'IXQ'
            }
        ],
        contact: {
            slack: '#support-index'
        }
    },
    'knowledge-core': {
        slug: 'knowledge-core',
        displayName: 'Knowledge Core',
        aliases: [
            'service-core'
        ],
        units: [
            'knowledge'
        ],
        jiraProjects: [
            {
                key: 'SVCC'
            }
        ],
        contact: {
            slack: '#support-service-rd'
        }
    },
    'knowledge-data': {
        slug: 'knowledge-data',
        displayName: 'Knowledge Data',
        aliases: [
            'ctsvc',
            'service-data'
        ],
        units: [
            'knowledge'
        ],
        jiraProjects: [
            {
                key: 'SVCDATA'
            }
        ],
        contact: {}
    },
    'knowledge-hub': {
        slug: 'knowledge-hub',
        displayName: 'Knowledge Hub Experience',
        aliases: [
            'knowledge-hub-experience',
            'service-hub'
        ],
        units: [
            'knowledge'
        ],
        jiraProjects: [
            {
                key: 'KHUB'
            }
        ],
        contact: {}
    },
    'knowledge-integrations': {
        slug: 'knowledge-integrations',
        displayName: 'Knowledge Integrations',
        aliases: [
            'salesforce-integration',
            'service-integrations'
        ],
        units: [
            'knowledge'
        ],
        jiraProjects: [
            {
                key: 'SFINT'
            }
        ],
        contact: {
            slack: '#support-service-rd'
        }
    },
    'llm-ops': {
        slug: 'llm-ops',
        displayName: 'LLM Ops',
        units: [
            'ml-platform'
        ],
        jiraProjects: [
            {
                key: 'LLMOPS'
            }
        ],
        contact: {
            supportPortals: [],
            slack: '#support-machine-learning'
        }
    },
    'marketing-website': {
        slug: 'marketing-website',
        displayName: 'Marketing Website Team',
        units: [
            'marketing'
        ],
        jiraProjects: [
            {
                key: 'WEBR'
            }
        ],
        contact: {
            slack: '#web-operations-sentry',
            supportPortals: []
        }
    },
    'ml-commerce-ai': {
        slug: 'ml-commerce-ai',
        displayName: 'ML Commerce AI',
        aliases: [
            'ml-profit',
            'ml-payg'
        ],
        units: [
            'applied-data-science'
        ],
        jiraProjects: [
            {
                key: 'COMAI'
            }
        ],
        contact: {
            slack: '#support-machine-learning'
        }
    },
    'ml-core-ai-dev': {
        slug: 'ml-core-ai-dev',
        displayName: 'ML Core AI Dev',
        aliases: [
            'ml-search-relevance',
            'ml-recommendations',
            'ml-query-suggest-and-understanding'
        ],
        units: [
            'ml-platform'
        ],
        jiraProjects: [
            {
                key: 'COREAI'
            }
        ],
        contact: {
            slack: '#support-machine-learning'
        }
    },
    'ml-core-nlp': {
        slug: 'ml-core-nlp',
        displayName: 'ML CoreNLP',
        units: [
            'applied-data-science'
        ],
        jiraProjects: [
            {
                key: 'CORENLP'
            }
        ],
        contact: {
            slack: '#core-nlp'
        }
    },
    'ml-experimentation-and-validation': {
        slug: 'ml-experimentation-and-validation',
        displayName: 'ML Experimentation and Validation',
        units: [
            'ml-platform'
        ],
        jiraProjects: [
            {
                key: 'MLPEV'
            }
        ],
        contact: {
            slack: '#support-machine-learning'
        }
    },
    'ml-knowai': {
        slug: 'ml-knowai',
        displayName: 'ML Knowledge AI',
        aliases: [
            'ml-service-ai',
            'ml-case-assist',
            'ml-smartsnippets'
        ],
        units: [
            'applied-data-science'
        ],
        jiraProjects: [
            {
                key: 'NLP'
            },
            {
                key: 'SVCAI'
            }
        ],
        contact: {
            slack: '#support-machine-learning'
        }
    },
    'ml-platform-building': {
        slug: 'ml-platform-building',
        displayName: 'ML Platform Building',
        aliases: [
            'ml-experience',
            'ml-platform-building-backend'
        ],
        units: [
            'ml-platform'
        ],
        jiraProjects: [
            {
                key: 'MLPB'
            }
        ],
        contact: {
            slack: '#support-machine-learning'
        }
    },
    'ml-platform-serving': {
        slug: 'ml-platform-serving',
        displayName: 'ML Platform Serving',
        aliases: [
            'ml-services'
        ],
        units: [
            'ml-platform'
        ],
        jiraProjects: [
            {
                key: 'MLPS'
            }
        ],
        contact: {
            slack: '#support-machine-learning'
        }
    },
    'native-connectivity': {
        slug: 'native-connectivity',
        displayName: 'Native Connectivity',
        aliases: [
            'service-connectivity',
            'wpc'
        ],
        units: [
            'content-ingestion'
        ],
        jiraProjects: [
            {
                key: 'CTNAT'
            }
        ],
        contact: {
            slack: '#community-content-ingestion'
        }
    },
    offsec: {
        slug: 'offsec',
        displayName: 'Offensive Security',
        units: [
            'corpo-security'
        ],
        jiraProjects: [
            {
                key: 'CSEC'
            },
            {
                key: 'OFFSEC'
            }
        ],
        contact: {
            slack: '#security',
            supportPortals: [
                {
                    label: "Offensive Security's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/11'
                }
            ]
        }
    },
    'platform-identity-and-entitlements': {
        slug: 'platform-identity-and-entitlements',
        displayName: 'Platform Identity And Entitlements',
        aliases: [
            'organization'
        ],
        units: [
            'platform-solution'
        ],
        jiraProjects: [
            {
                key: 'PIE'
            }
        ],
        contact: {
            slack: '#community-platform-solution'
        }
    },
    'platform-resource-insight': {
        slug: 'platform-resource-insight',
        displayName: 'Platform Resource Insight',
        aliases: [
            'source',
            'sources'
        ],
        units: [
            'platform-solution'
        ],
        jiraProjects: [
            {
                key: 'PRI'
            }
        ],
        contact: {
            slack: '#community-platform-solution'
        }
    },
    'platform-solution-experience': {
        slug: 'platform-solution-experience',
        displayName: 'Platform Solution Experience',
        units: [
            'platform-solution'
        ],
        jiraProjects: [
            {
                key: 'PSE'
            }
        ],
        contact: {
            slack: '#community-platform-solution'
        }
    },
    'product-intelligence': {
        slug: 'product-intelligence',
        displayName: 'Product Intelligence',
        units: [
            'advisors-and-specialists'
        ],
        jiraProjects: [
            {
                key: 'PINT'
            },
            {
                key: 'DASH'
            },
            {
                key: 'AMP'
            }
        ],
        contact: {
            slack: '#product-intelligence'
        }
    },
    'real-time-platform': {
        slug: 'real-time-platform',
        displayName: 'Real Time Platform',
        aliases: [
            'commerce-core'
        ],
        units: [
            'data-platform'
        ],
        jiraProjects: [
            {
                key: 'CCC'
            }
        ],
        contact: {
            slack: '#support-dataplatform'
        }
    },
    searchapi: {
        slug: 'searchapi',
        displayName: 'Search API',
        aliases: [
            'search-api'
        ],
        units: [
            'query-execution'
        ],
        jiraProjects: [
            {
                key: 'SEARCHAPI'
            }
        ],
        contact: {
            slack: '#support-searchapi'
        }
    },
    'security-cache': {
        slug: 'security-cache',
        displayName: 'Security Cache',
        units: [
            'query-execution'
        ],
        jiraProjects: [
            {
                key: 'SECCACHE'
            }
        ],
        contact: {
            slack: '#support-security-cache'
        }
    },
    security: {
        slug: 'security',
        displayName: 'Security',
        aliases: [
            'rd-defense',
            'security-defense-systems-blue',
            'csec'
        ],
        units: [
            'corpo-security'
        ],
        jiraProjects: [
            {
                key: 'DEF'
            },
            {
                key: 'PES'
            },
            {
                key: 'RDDR'
            },
            {
                key: 'RVR'
            }
        ],
        contact: {
            slack: '#security',
            supportPortals: [
                {
                    label: "Security Engineering's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/83/group/146'
                }
            ]
        }
    },
    soc: {
        slug: 'soc',
        displayName: 'Security Operation Center',
        units: [
            'corpo-security'
        ],
        jiraProjects: [
            {
                key: 'SOC'
            }
        ],
        contact: {
            slack: '#security',
            supportPortals: [
                {
                    label: "Security Operation Center's support portal",
                    url: 'https://coveord.atlassian.net/servicedesk/customer/portal/116'
                }
            ]
        }
    },
    'transformation-and-enablement': {
        slug: 'transformation-and-enablement',
        displayName: 'Transformation & Enablement',
        aliases: [
            'cloud-advisor',
            'cloudadvisors'
        ],
        units: [
            'platform-engineering'
        ],
        jiraProjects: [
            {
                key: 'CA'
            }
        ],
        contact: {
            slack: '#peng-transformation'
        }
    }
};

//# sourceMappingURL=Teams.js.map